import Kfit from 'integrations/Kfit';
import DataLoader from 'dataloader';

const Repo = new DataLoader(
  keys => Promise.all(keys.map(key => Kfit.get(key))),
  {
    batch: false,
    cacheKeyFn: key => JSON.stringify(key)
  }
);

function loadInfo(key, reload) {
  if (reload) Repo.clearAll();
  return Repo.load(key);
}

export default () => loadInfo(`/v6/bank_infos`);
